// Libraries
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../store/hooks';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { Container } from '@mui/material';

// Api
import companyApi from '../api/companyApi';

// Core
import { ResourceTextApplication } from '../core/resources';
import FormValidator from '../core/FormValidator';

// Feature
import ContentTitle from '../dashboard/shared/ContentTitle';
import AllContracts from './AllContracts';
import FarmContracts from './FarmContracts';
import { IFarmDetails } from '../interfaces/IBusinessEntities';
import { CompanyEntityTypeEnum } from '../interfaces/enums';
import { AInputItem, ARadioButtonGroupInputValue, ARadioButtons } from '../common/inputs';

export default function Contracts() {
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaContract']);
    const { enqueueSnackbar } = useSnackbar();

    const context = useAppSelector((state) => state.context);
    const [farm, setFarm] = useState<IFarmDetails | null>(null);

    const [loadingCompany, setLoadingCompany] = useState<boolean>(true);

    const [view, setView] = useState<string>('farm');

    useEffect(() => {
        setLoadingCompany(true);
        getFarm();
    }, [context]);

    useEffect(() => {
        if (farm) {
            setLoadingCompany(false);
        }
    }, [farm]);

    const getFarm = () => {
        if (context?.data?.currentContext) {
            companyApi.getCompanyByContext(context.data.currentContext.context).then((response) => {
                if (!response) {
                    enqueueSnackbar(t('AnelmaGeneral:1020'), {
                        variant: 'error',
                    });
                } else {
                    let data = response.Entity as IFarmDetails;

                    if (data.CompanyType && data.CompanyType === CompanyEntityTypeEnum.Farm)
                        setFarm(data);
                }
            });
        }
    };

    const getItems: AInputItem<ARadioButtonGroupInputValue>[] = [
        {
            text: t('AnelmaContract:1021'),
            value: 'farm',
        },
        {
            text: t('AnelmaContract:1037'),
            value: 'all',
        },
    ];

    const producerView = <FarmContracts farm={farm} loading={loadingCompany} />;

    const allContractsView = <AllContracts farm={farm} loading={loadingCompany} />;

    const mainView = view === 'all' ? allContractsView : producerView;

    return (
        <Container>
            <ContentTitle>{t('AnelmaContract:1000')}</ContentTitle>

            <ARadioButtons
                id='view-toggle'
                items={getItems}
                onChange={(e) => setView(e?.toString() ?? 'farm')}
                validator={new FormValidator()}
                value={'farm'}
                withoutContainer
            />

            {mainView}
        </Container>
    );
}
